module.exports = __webpack_public_path__ + "static/doctor-heart-woman-9e14085d595f79df4474e8fda3adcc62.png";